import { getClient } from '@/api/api-client';
import type { IEmailTemplate } from '@condo/domain';

export const fetchEmailTempaltes = async (): Promise<IEmailTemplate[]> =>
    getClient('basecamp')
        .get('/email-templates')
        .then(response => response.data.emailTemplates);

export const saveEmailTemplate = async (emailTemplate: Partial<IEmailTemplate>): Promise<IEmailTemplate> =>
    getClient('basecamp')
        .put('/email-templates', emailTemplate)
        .then(response => response.data.emailTemplate);
